module.exports = __webpack_public_path__ + "static/media/laugh-beam-regular.d8c83fd1.svg";